export default [
  {
    heading: 'Commercial',
    scope: [
      'bookings.read',
      'faces.read',
      'displays.read',
      'clients.read',
      'campaigns.read',
      'visuals.read',
      'baskets.read',
    ],
  },
  {
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    text: 'Parc',
    scope: ['clients.read', 'campaigns.read', 'visuals.read', 'baskets.read'],
    children: [
      { icon: 'dashboard', text: 'Dashboard', link: {name: 'faces'}, scope: ['bookings.create'] },
      { icon: 'airplay', text: 'Disponibilités', link: {name: 'available'}, scope: ['faces.read'] },
      { icon: 'alarm', text: 'Libérations futures', link: {name: 'futurview'}, scope: ['faces.read'] },
      { icon: 'pan_tool', text: 'Réservations', link: {name: 'bookingsview'}, scope: ['bookings.create'] },
      { icon: 'aspect_ratio', text: 'Affichages', link: {name: 'displays'}, scope: ['bookings.create'] },
    ],
  },
  {
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    text: 'Gestion clientèle',
    scope: ['clients.create', 'campaigns.create', 'visuals.create', 'baskets.create'],
    children: [
      { icon: 'fas fa-handshake', text: 'Clients', link: {name: 'clients'}, scope: ['clients.create'] },
      { icon: 'fas fa-shopping-basket', text: 'Paniers', link: {name: 'baskets'}, scope: ['baskets.create'] },
      { icon: 'fas fa-fire', text: 'Campagnes', link: {name: 'campaigns'}, scope: ['campaigns.create'] },
    ],
  },
  { heading: 'Technique', scope: ['incidents.delete'] },
  {
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    text: 'Incidents',
    scope: ['incidents.delete'], // this makes no sense, but I use it to limit access
    children: [
      { icon: 'reports', text: 'Incidents', link: {name: 'incidents'} },
      { icon: 'broken_image', text: 'Types', link: {name: 'incidenttypes'}, scope: ['incidenttypes.read'] },
      { icon: 'build', text: 'Interventions', link: {name: 'interventiontypes'}, scope: ['interventiontypes.read'] },
    ],
  },
  {
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    text: 'Panneaux',
    scope: ['incidents.delete'], // this makes no sense, but I use it to limit access
    children: [
      { icon: 'extension', text: 'Catégories', link: {name: 'boardtypes'} },
      { icon: 'perm_media', text: 'Panneaux', link: {name: 'boards'} },
    ],
  },
  {
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    text: 'Géographie',
    scope: ['incidents.delete'], // this makes no sense, but I use it to limit access
    children: [
      { icon: 'public', text: 'Régions', link: {name: 'regions'} },
      { icon: 'location_city', text: 'Villes', link: {name: 'cities'} },
      { icon: 'domain', text: 'Districts', link: {name: 'districts'} },
    ],
  },
  { heading: 'Analyse', scope: ['stats.read'] },
  {
    icon: 'keyboard_arrow_up',
    'icon-alt': 'keyboard_arrow_down',
    text: 'Statitiques',
    scope: ['stats.read'],
    children: [
      // { icon: 'timeline', text: 'Sommaire', link: {name: 'summary'} },
      { icon: 'dashboard', text: 'Sommaire', link: {name: 'summary'} },
      { icon: 'dashboard', text: 'Impressions par type', link: {name: 'displayprints'} },
      { icon: 'dashboard', text: 'Affichages par région', link: {name: 'displayregions'} },
      { icon: 'dashboard', text: 'Incidents par région', link: {name: 'incidentregions'} },
      { icon: 'dashboard', text: 'Incidents par intervenant', link: {name: 'incidentusers'} },
      { icon: 'search', text: 'Occupation', link: {name: 'tenancy'} },
    ],
  },
  { heading: 'Système' },
  { icon: 'people', text: 'Utilisateurs', link: {name: 'users'}, scope: ['users.read'] },
  { icon: 'settings', text: 'Configuration', link: {name: 'settings'} },
]
